import * as React from "react";
import * as styles from "./SpeechControls.css";

const speechControlsCrossFadeDurationInMilliseconds = 220;

export function SpeechControlsCrossFade({
    transitionKey,
    showGradient,
    children,
}: {
    transitionKey: string;
    showGradient: boolean;
    children: React.ReactNode;
}) {
    const currentContentRef = React.useRef(children);
    const currentKeyRef = React.useRef(transitionKey);
    const [currentContent, setCurrentContent] = React.useState(children);
    const [previousContent, setPreviousContent] =
        React.useState<React.ReactNode>(null);
    const [previousKey, setPreviousKey] = React.useState<string | null>(null);

    React.useEffect(() => {
        if (transitionKey === currentKeyRef.current) {
            return;
        }

        setPreviousContent(currentContentRef.current);
        setPreviousKey(currentKeyRef.current);
        setCurrentContent(children);
        currentContentRef.current = children;
        currentKeyRef.current = transitionKey;

        const timeoutId = window.setTimeout(
            () => {
                setPreviousContent(null);
                setPreviousKey(null);
            },
            speechControlsCrossFadeDurationInMilliseconds
        );

        return () => window.clearTimeout(timeoutId);
    }, [transitionKey]);

    return (
        <span
            className={`${styles.crossFade} ${
                showGradient ? "" : styles.crossFadeWithoutGradient
            }`}
        >
            {previousContent ? (
                <span
                    className={styles.fadeOut}
                    key={`fadeOut_${previousKey}`}
                >
                    {previousContent}
                </span>
            ) : null}
            <span
                className={styles.fadeIn}
                key={`fadeIn_${currentKeyRef.current}`}
            >
                {currentContent}
            </span>
        </span>
    );
}
